import { Controller } from "@hotwired/stimulus"
import Inputmask from "inputmask"

export default class extends Controller {
  static values = {
    creationMode: String,
    singleRegex: String,
    massRegex: String
  }

  static targets = [ "input" ]

  creationModeValueChanged() {
    const massCreation = this.creationModeValue === "mass"
    this.inputTargets.forEach(input => {
      if (massCreation)
        Inputmask({ regex: this.massRegexValue }).mask(input)
      else
        Inputmask({ regex: this.singleRegexValue }).mask(input)
    })
  }

  changeMode({ params }) {
    this.creationModeValue = params.mode
  }
}